type Options = {
  plural?: boolean
}

export function getEntityTypeFromPathname(pathname: string, {plural} : Options = {}) {

  if (pathname.includes('leads')) return plural ? 'leads' : 'Lead'
  if (pathname.includes('accounts')) return plural ? 'accounts' : 'Account'
  if (pathname.includes('contacts')) return plural ? 'contacts' : 'Contact'
  if (pathname.includes('opportunities')) return plural ? 'opportunities' : 'Opportunity'
  if (pathname.includes('sites')) return plural ? 'sites' : 'Site'
  if (pathname.includes('campaigns')) return plural ? 'campaigns' : 'Campaign'
  throw new Error('Could not get entity from pathname')
}
